import { useNavigate } from "react-router-dom";
import { FaUser, FaBox, FaArchive } from "react-icons/fa";
import styles from "../styles/ProductDashboard.module.css";

export default function ProductDashboard() {
  const navigate = useNavigate();

  return (
    <div className={styles.dashboard}>
      <h1 className={styles.title}>Bspark Dashboard</h1>

      <div className={styles.cards}>

  {/* USERS CARD */}
  <div
    className={`${styles.card} ${styles.usersCard}`}
    onClick={() => navigate("/users")}
  >
    <div className={styles.icon}>
      <FaUser />
    </div>
    <h2>Users</h2>
    <p>Manage registered users</p>
    <span className={styles.action}>View →</span>
  </div>

  {/* PRODUCTS CARD – now vertical */}
  <div
    className={`${styles.card} ${styles.productsCard}`}
    onClick={() => navigate("/products")}
  >
    <div className={styles.icon}>
      <FaArchive />
    </div>
    <h2>Products</h2>
    <p>View products</p>
    <span className={styles.action}>Manage →</span>
  </div>
</div>

    </div>
  );
}
